import styled, { css, keyframes } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/radius';

const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(173,255,1,0.0), 0 10px 34px rgba(173,255,1,0.10); }
  50% { box-shadow: 0 0 0 6px rgba(173,255,1,0.08), 0 16px 44px rgba(173,255,1,0.2); }
`;

interface IStyCardContainer {
  $isPremium?: boolean;
}

export const StyCardContainer = styled.div<IStyCardContainer>`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-height: 587px;
  padding: ${SPACING._24};
  border: 1px solid
    ${({ theme, $isPremium }) =>
      $isPremium ? theme.primary : theme.neutral800};
  border-radius: ${RADIUS._8};
  transition: 200ms;

  ${({ $isPremium, theme }) =>
    $isPremium &&
    css`
      &:hover {
        transform: scale(1.01);
      }

      > button {
        filter: brightness(0.9);
        &:hover {
          filter: brightness(1.1);
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 3px;
        background: linear-gradient(
          90deg,
          transparent,
          ${theme.primary},
          transparent
        );
        box-shadow: 0 8px 24px ${theme.primary}40;
        pointer-events: none;
      }

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(
            circle at 20% 0%,
            ${theme.primary}25,
            transparent 45%
          ),
          radial-gradient(
            circle at 80% 40%,
            rgba(255, 255, 255, 0.05),
            transparent 50%
          );
        pointer-events: none;
        opacity: 0.9;
      }

      border-color: ${theme.primary};
      animation: ${pulse} 2.2s ease-in-out infinite;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
      }
    `}
`;

export const StyAdvantageous = styled.div`
  position: absolute;
  top: -10px;
  width: fit-content;
  background-color: ${({ theme }) => theme.primary};
  padding: ${SPACING._4} ${SPACING._16};
  border-radius: ${RADIUS._999};
  filter: drop-shadow(2px 4px 8px rgba(0, 0, 0, 0.5));
`;

export const StyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  padding-bottom: ${SPACING._24};
`;

export const StyTitleContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._4};
`;

export const StyValueContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const StyComparisonPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._4};
  opacity: 0.85;
`;

export const StyPrimaryPriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${SPACING._4};
  flex-wrap: wrap;
`;

export const StyAnnualNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._6};
  padding: ${SPACING._12};
  border: 1px solid ${({ theme }) => theme.neutral800};
  border-radius: ${RADIUS._8};
  background: ${({ theme }) => theme.neutral950};
`;

export const StyOptionsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
`;

export const StyOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._8};
`;
